<template>
  <div class="public-footer-wrapper">
    <!-- ===================================================== -->
    <!-- MAIN FOOTER -->
    <!-- ===================================================== -->

    <v-footer
      height="auto"
      padless
      class="public-footer responsive-x-padding"
      :style="{
        ...sysTypo.sectionTypography.body,
        background: themeStore.sectionTheme.footerBarBg, color: themeStore.sectionTheme.footerColor
      }"
    >
      <v-container
        fluid
       class="responsive-x-padding"
      >
        <v-row class="formattoprow footer-content">
          <!-- ================================================= -->
          <!-- FOOTER CATEGORIES -->
          <!-- ================================================= -->

          <v-col
            v-for="cat in footerCategories"
            :key="cat.actfootidn"
            cols="12"
            sm="6"
            md="3"
            class="footer-column"
          >
            <div class="footer-category-heading">
              <div
                class="footer-category-icon"
                :style="{
                  ...sysTypo.sectionTypography.body,
                  background: themeStore.sectionTheme.footerBarBg, color: themeStore.sectionTheme.footerColor
                }"
              >
                <v-icon
                  size="26"
                  :icon="getMdiIcon(cat) || 'mdi-link-variant'"
                  :style="{ ...sysTypo.sectionTypography.body,
                    color: themeStore.sectionTheme.footerBtnColor
                  }"
                />
              </div>

              <div>
                <h3
                  class="formatfootercat"
                  :style="{ ...sysTypo.sectionTypography.h3,
                    color: themeStore.sectionTheme.footerColor
                  }"
                >
                  {{ getCategoryDescription(cat) }}
                </h3>

                <div
                  class="footer-heading-underline"
                  :style="{ ...sysTypo.sectionTypography.body,
                    color: themeStore.sectionTheme.footerColor
                  }"
                />
              </div>
            </div>

            <!-- ================================================= -->
            <!-- FOOTER LINKS -->
            <!-- ================================================= -->

            <nav
              class="footer-links"
              :aria-label="
                getCategoryDescription(cat)
              "
            >
              <template
                v-for="link in getLinksForCategory(
                  cat.actfootidn
                )"
                :key="link.actfootid"
              >
                <!-- DYNAMIC / INTERNAL -->

                <router-link
                  v-if="getFooterRoute(link)"
                  :to="getFooterRoute(link)"
                  class="footer-link"
                  :style="{ ...sysTypo.sectionTypography.body,
                    color: themeStore.sectionTheme.footerColor
                  }"
                >
                  <v-icon
                    size="17"
                    class="footer-link-icon"
                   :style="{ ...sysTypo.sectionTypography.body,
                    color: themeStore.sectionTheme.footerBtnColor
                  }"
                    :icon="getMdiIcon(link) || 'mdi-chevron-right'"
                  />

                  <span :style="{ ...sysTypo.sectionTypography.body,
                    color: themeStore.sectionTheme.footerColor
                  }">
                    {{ getLinkDescription(link) }}
                  </span>
                </router-link>

                <!-- EXTERNAL -->

                <a
                  v-else-if="
                    getFooterExternalUrl(link)
                  "
                  :href="
                    getFooterExternalUrl(link)
                  "
                  class="footer-link"
                  :style="{ ...sysTypo.sectionTypography.body,
                    color: themeStore.sectionTheme.footerColor
                  }"
                  :target="
                    link.openInNewTab
                      ? '_blank'
                      : '_self'
                  "
                  :rel="
                    link.openInNewTab
                      ? 'noopener noreferrer'
                      : undefined
                  "
                >
                  <v-icon
                    size="17"
                    class="footer-link-icon"
                    :style="{ ...sysTypo.sectionTypography.body,
                    color: themeStore.sectionTheme.footerColor
                  }"
                    :icon="getMdiIcon(link) || 'mdi-open-in-new'"
                  />

                  <span>
                    {{ getLinkDescription(link) }}
                  </span>
                </a>

                <!-- INVALID / UNPUBLISHED -->

                <span
                  v-else
                  class="
                    footer-link
                    footer-link--disabled
                  "
                  :style="{ ...sysTypo.sectionTypography.body,
                    color: themeStore.sectionTheme.footerColor
                  }"
                >
                  <v-icon
                    size="17"
                    class="footer-link-icon"
                    :style="{ ...sysTypo.sectionTypography.body,
                    color: themeStore.sectionTheme.footerBtnColor
                  }"
                    :icon="getMdiIcon(link) || 'mdi-minus'"
                  />

                  <span>
                    {{ getLinkDescription(link) }}
                  </span>
                </span>
              </template>
            </nav>
          </v-col>

          <!-- ================================================= -->
          <!-- FOOTER ABOUT -->
          <!-- ================================================= -->

          <v-col
            v-for="fabout in footerAbout"
            :key="fabout.abfootid"
            cols="12"
            sm="6"
            md="3"
            class="footer-about-column"
          >
            <!-- LOGO -->

            <router-link
              :to="{
                name: 'PublicHome'
              }"
              class="footer-logo-link"
            >
              <v-img
                :src="fabout.imPagePath"
                contain
                class="footer-logo"
              />
            </router-link>

            <!-- DESCRIPTION -->

            <AboutPageDirectoryPublicCompact />
          </v-col>
        </v-row>
      </v-container>

      <!-- ===================================================== -->
      <!-- COOKIE DIALOG -->
      <!-- ===================================================== -->

      <ManageCookies
        v-model:cookiesdialog="showCookiesDialog"
        :getcookiesval="getCookieVal"
      />
    </v-footer>

    <!-- ===================================================== -->
    <!-- BOTTOM BAR -->
    <!-- ===================================================== -->

    <div
      class="footer-bottom"
      :style="{ 
        ...sysTypo.sectionTypography.body,
        background: themeStore.sectionTheme.footerLastDivBtnBg, color: themeStore.sectionTheme.footerLastDivColor
      }"
    >
      <v-container
        fluid
        class="responsive-x-padding"
      >
        <v-divider
          class="footer-divider"
          :style="{ 
            ...sysTypo.sectionTypography.body,
            color: themeStore.sectionTheme.footerColor
          }"
        />

        <div class="footer-bottom-content"
        :style="{ 
            ...sysTypo.sectionTypography.body,
            color: themeStore.sectionTheme.footerLastDivColor
          }"
        >
          <!-- ================================================= -->
          <!-- POLICY LINKS -->
          <!-- ================================================= -->

          <div class="footer-policy-links" 
          
          >
            <!-- PRIVACY -->

            <button
              type="button"
              class="privacycss"
             
              @click="openPrivacypolicy"
            >
              <v-icon
                size="16"
                 :style="{ 
                ...sysTypo.sectionTypography.body,
                color: themeStore.sectionTheme.appFooterLastDivBtnColor
              }"
              >
                mdi-shield-lock-outline
              </v-icon>

              <span :style="{ 
                ...sysTypo.sectionTypography.body,
                color: themeStore.sectionTheme.appFooterLastDivBtnColor
              }">
                {{ t('nbt00000000014') }}
              </span>
            </button>

            <!-- COOKIES -->

            <button
              type="button"
              class="privacycss"
                @click="openCookiesDialog"
            >
              <v-icon
                size="16"
                 :style="{ 
                ...sysTypo.sectionTypography.body,
                color: themeStore.sectionTheme.appFooterLastDivBtnColor
              }"
              >
                mdi-cookie-outline
              </v-icon>

              <span>
                {{ t('nbt00000000015') }}
              </span>
            </button>

            <!-- TERMS -->

            <button
              type="button"
              class="privacycss"
 
              @click="openTermsofuse"
            >
              <v-icon
                size="16"
                 :style="{ 
                ...sysTypo.sectionTypography.body,
                color: themeStore.sectionTheme.appFooterLastDivBtnColor
              }"
              >
                mdi-file-document-outline
              </v-icon>

              <span :style="{ 
                ...sysTypo.sectionTypography.body,
                color: themeStore.sectionTheme.appFooterLastDivBtnColor
              }">
                {{ t('nbt00000000016') }}
              </span>
            </button>
          </div>

          <!-- ================================================= -->
          <!-- COMPANY INFORMATION -->
          <!-- ================================================= -->

          <div class="footer-company-information" v-for="fabout in footerAbout" :key="fabout.abfootid">
            <i
              class="
                privacycss
                footer-location
              "
                
            >
              <v-icon
                size="16"
                :style="{ 
                ...sysTypo.sectionTypography.body,
                color: themeStore.sectionTheme.appFooterLastDivBtnColor
              }"
              >
                mdi-map-marker-outline
              </v-icon>

              <span>
                {{fabout.locationAddress}}
              </span>
            </i>

            <a
              class="privacycss"
              :href="getdomain"
              :style="{ 
                ...sysTypo.sectionTypography.body,
                color: themeStore.sectionTheme.appFooterLastDivBtnColor
              }"
            >
              <span
               :style="{ 
                ...sysTypo.sectionTypography.body,
                color: themeStore.sectionTheme.appFooterLastDivBtnColor
              }"
              >
                &copy;
              {{ currentYear }}
              {{fabout.copyright}}
              </span>
              
            </a>
          </div>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  onMounted,
  computed,
  watch
} from 'vue'

import {
  useRouter
} from 'vue-router'

import {
  useToast
} from 'vue-toastification'

import {
  useI18n
} from 'vue-i18n'

import publicApi from '@/auth/publicApi'

import ManageCookies from './ManageCookies.vue'

import AboutPageDirectoryPublicCompact from "./AboutPageDirectoryPublicCompact.vue"
import { useLangStore } from "@/store/lang"
import { useThemeStore, useAuthStore } from "@/store/auth"

import { useSysTypo } from "@/store/useSysTypo";
const sysTypo = useSysTypo();
const themeStore = useThemeStore()

const getdomain = window.location.origin;

// ============================================================
// I18N
// ============================================================

const {
  t,
  locale
} =
  useI18n()

// ============================================================
// STORES
// ============================================================

const lang =
  useLangStore()


const auth =
  useAuthStore()

// ============================================================
// LANGUAGE
// ============================================================

watch(
  () =>
    lang.currentLanguage,

  newLang => {
    locale.value =
      newLang
  },

  {
    immediate:
      true
  }
)

// ============================================================
// SERVICES
// ============================================================

const toast =
  useToast()

const router =
  useRouter()

// ============================================================
// DATA
// ============================================================

const footerAbout =
  ref([])

const footerCategories =
  ref([])

const getfooterLinks =
  ref([])

// ============================================================
// COOKIE DIALOG
// ============================================================

const showCookiesDialog =
  ref(false)

const getCookieVal =
  ref(null)

// ============================================================
// LANGUAGE
// ============================================================

const currentLanguage =
  computed(() =>
    lang.currentLanguage ===
    'fr'
      ? 'fr'
      : 'en'
  )

// ============================================================
// YEAR
// ============================================================

const currentYear =
  computed(() =>
    new Date().getFullYear()
  )

// ============================================================
// NORMALIZE API ARRAY
// ============================================================

function normalizeArray(
  data
) {
  if (
    Array.isArray(data)
  ) {
    return data
  }

  if (
    Array.isArray(
      data?.data
    )
  ) {
    return data.data
  }

  if (
    Array.isArray(
      data?.items
    )
  ) {
    return data.items
  }

  if (
    Array.isArray(
      data?.results
    )
  ) {
    return data.results
  }

  return []
}

// ============================================================
// CLEAN VALUE
// ============================================================

function cleanValue(
  value
) {
  const normalized =
    String(
      value ??
      ''
    ).trim()

  if (
    !normalized ||
    normalized === '#' ||
    normalized
      .toLowerCase() ===
      'null' ||
    normalized
      .toLowerCase() ===
      'undefined'
  ) {
    return ''
  }

  return normalized
}

// ============================================================
// EXTERNAL URL
// ============================================================

function isExternalUrl(
  value
) {
  return /^(https?:)?\/\//i.test(
    cleanValue(value)
  )
}

// ============================================================
// CATEGORY LINKS
// ============================================================

function getLinksForCategory(
  categoryId
) {
  return getfooterLinks.value.filter(
    link =>
      String(
        link.actrefId
      ) ===
      String(
        categoryId
      )
  )
}

// ============================================================
// CATEGORY DESCRIPTION
// ============================================================

function getCategoryDescription(
  category
) {
  if (
    currentLanguage.value ===
    'fr'
  ) {
    return (
      category?.footcatdescFr ||
      category?.footcatdescFR ||
      category?.footcatdesc ||
      ''
    )
  }

  return (
    category?.footcatdesc ||
    category?.footcatdescFr ||
    category?.footcatdescFR ||
    ''
  )
}

// ============================================================
// LINK DESCRIPTION
// ============================================================

function getLinkDescription(
  link
) {
  if (
    currentLanguage.value ===
    'fr'
  ) {
    return (
      link?.actshortdescFr ||
      link?.actshortdescFR ||
      link?.actshortdesc ||
      ''
    )
  }

  return (
    link?.actshortdesc ||
    link?.actshortdescFr ||
    link?.actshortdescFR ||
    ''
  )
}

// ============================================================
// LINK / CATEGORY MDI ICON
// ============================================================

function getMdiIcon(
  item
) {
  return cleanValue(
    item?.mdiIcon ??
    item?.MdiIcon
  )
}

// ============================================================
// ABOUT DESCRIPTION
// ============================================================

function getAboutDescription(
  about
) {
  if (
    currentLanguage.value ===
    'fr'
  ) {
    return (
      about?.abshortdescFr ||
      about?.abshortdescFR ||
      about?.abshortdesc ||
      ''
    )
  }

  return (
    about?.abshortdesc ||
    about?.abshortdescFr ||
    about?.abshortdescFR ||
    ''
  )
}

// ============================================================
// DYNAMIC PAGE ROUTE
// ============================================================

function getDynamicPageRoute(
  link
) {
  if (
    !link?.dynamicPageId
  ) {
    return undefined
  }

  if (
    link.dynamicPageIsPublished !==
    true
  ) {
    return undefined
  }

  const slug =
    currentLanguage.value ===
    'fr'
      ? cleanValue(
          link.dynamicPageSlugFr ||
          link.dynamicPageSlugEn
        )
      : cleanValue(
          link.dynamicPageSlugEn ||
          link.dynamicPageSlugFr
        )

  if (!slug) {
    return undefined
  }

  return {
    name:
      'DynamicPublicPage',

    params: {
      lang:
        currentLanguage.value,

      pagePath:
        slug
          .replace(
            /^\/+|\/+$/g,
            ''
          )
          .split('/')
          .map(
            segment =>
              segment.trim()
          )
          .filter(Boolean)
    }
  }
}

// ============================================================
// INTERNAL FOOTER ROUTE
// ============================================================

function getFooterRoute(
  link
) {
  if (!link) {
    return undefined
  }

  const dynamicRoute =
    getDynamicPageRoute(
      link
    )

  if (
    dynamicRoute
  ) {
    return dynamicRoute
  }

  if (
    link.dynamicPageId
  ) {
    return undefined
  }

  const routeValue =
    currentLanguage.value ===
    'fr'
      ? cleanValue(
          link.actsUrlPath_Fr ||
          link.actsUrlPathFr ||
          link.actsUrlPath
        )
      : cleanValue(
          link.actsUrlPath ||
          link.actsUrlPath_Fr ||
          link.actsUrlPathFr
        )

  if (
    !routeValue ||
    isExternalUrl(
      routeValue
    )
  ) {
    return undefined
  }

  if (
    router.hasRoute(
      routeValue
    )
  ) {
    return {
      name:
        routeValue
    }
  }

  if (
    routeValue.startsWith(
      '/'
    )
  ) {
    return {
      path:
        routeValue
    }
  }

  return {
    path:
      `/${currentLanguage.value}/` +
      routeValue.replace(
        /^\/+/,
        ''
      )
  }
}

// ============================================================
// EXTERNAL FOOTER URL
// ============================================================

function getFooterExternalUrl(
  link
) {
  if (
    !link ||
    link.dynamicPageId
  ) {
    return undefined
  }

  const value =
    currentLanguage.value ===
    'fr'
      ? cleanValue(
          link.actsUrlPath_Fr ||
          link.actsUrlPathFr ||
          link.actsUrlPath
        )
      : cleanValue(
          link.actsUrlPath ||
          link.actsUrlPath_Fr ||
          link.actsUrlPathFr
        )

  return isExternalUrl(
    value
  )
    ? value
    : undefined
}

// ============================================================
// PHONE
// ============================================================

function normalizePhone(
  value
) {
  return String(
    value ??
    ''
  ).replace(
    /[^\d+]/g,
    ''
  )
}

// ============================================================
// COOKIE / POLICY DIALOG
// ============================================================

function openCookiesDialog() {
  getCookieVal.value =
    'cookies_policy'

  showCookiesDialog.value =
    true
}

function openPrivacypolicy() {
  getCookieVal.value =
    'privacy_policy'

  showCookiesDialog.value =
    true
}

function openTermsofuse() {
  getCookieVal.value =
    'terms_of_use'

  showCookiesDialog.value =
    true
}

function openSitemap() {
  getCookieVal.value =
    'site_map'

  showCookiesDialog.value =
    true
}

// ============================================================
// FETCH
// ============================================================

async function fetchItems() {
  try {
    const [
      categoryResponse,
      aboutResponse,
      linkResponse
    ] =
      await Promise.all([
        publicApi.get(
          '/FooterCategory'
        ),

        publicApi.get(
          '/FooterAbout'
        ),

        publicApi.get(
          '/FooterLink'
        )
      ])

    footerCategories.value =
      normalizeArray(
        categoryResponse.data
      )

    footerAbout.value =
      normalizeArray(
        aboutResponse.data
      )

    getfooterLinks.value =
      normalizeArray(
        linkResponse.data
      )
  }
  catch (error) {
    console.error(
      'Failed to load footer information:',
      error
    )

    footerCategories.value =
      []

    footerAbout.value =
      []

    getfooterLinks.value =
      []

    toast.error(
      error?.response?.data
        ?.message ||
      error?.response?.data
        ?.detail ||
      'Failed to load footer information.'
    )
  }
}

// ============================================================
// MOUNT
// ============================================================

onMounted(
  fetchItems
)
</script>

<style scoped>
/* ============================================================
   RESPONSIVE X PADDING
============================================================ */

.responsive-x-padding {
  padding-right: 10px !important;
  padding-left: 10px !important;
}


/* ============================================================
   ROOT
============================================================ */

.public-footer-wrapper {
  width: 100%;
}


/* ============================================================
   SHARED RESPONSIVE HORIZONTAL PADDING
   SAME AS PUBLIC HEADER
============================================================ */

.responsive-x-padding {
  padding-right:
    10px !important;

  padding-left:
    10px !important;
}

@media (min-width: 600px) {
  .responsive-x-padding {
    padding-right:
      10px !important;

    padding-left:
      10px !important;
  }
}


/* ============================================================
   >= 960
============================================================ */

@media (min-width: 960px) {
  .responsive-x-padding {
    padding-right: 64px !important;
    padding-left: 64px !important;
  }
}


/* ============================================================
   >= 1280
============================================================ */

@media (min-width: 1280px) {
  .responsive-x-padding {
    padding-right: 80px !important;
    padding-left: 80px !important;
  }
}


/* ============================================================
   >= 1920
============================================================ */

@media (min-width: 1920px) {
  .responsive-x-padding {
    padding-right: 200px !important;
    padding-left: 200px !important;
  }
}


/* ============================================================
   MAIN FOOTER
============================================================ */

.public-footer {
  position: relative;

  z-index: 88;

  width: 100%;

  text-align: center;
}


/* ============================================================
   FOOTER CONTENT
============================================================ */

.footer-content {
  width: 100%;

  margin: 0;

  padding-top:
    50px;

  padding-bottom:
    50px;
}


/* ============================================================
   FOOTER COLUMN
============================================================ */

.footer-column {
  padding-top:
    18px;

  padding-bottom:
    18px;

  text-align: left;
}


/* ============================================================
   CATEGORY HEADING
============================================================ */

.footer-category-heading {
  display: flex;

  align-items: flex-start;

  gap: 12px;

  margin-bottom:
    20px;
}

.footer-category-icon {
  display: flex;

  flex:
    0
    0
    38px;

  width: 38px;
  height: 38px;

  align-items: center;
  justify-content: center;

  border-radius:
    11px;
}

.formatfootercat {
  margin: 0;

  font-size:
    20px;

  font-weight:
    700;

  line-height:
    1.4;
}

.footer-heading-underline {
  width:
    45px;

  height:
    3px;

  margin-top:
    8px;

  border-radius:
    999px;
}


/* ============================================================
   LINKS
============================================================ */

.footer-links {
  display: flex;

  flex-direction: column;

  gap:
    4px;
}

.footer-link {
  display: flex;

  min-height:
    38px;

  align-items: center;

  gap:
    7px;

  padding:
    7px
    8px;

  font-size:
    0.9rem;

  line-height:
    1.45;

  text-decoration:
    none;

  border-radius:
    8px;

  opacity:
    0.78;

  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}

.footer-link:hover {
  opacity:
    1;

  transform:
    translateX(4px);
}

.footer-link-icon {
  flex:
    0
    0
    auto;
}

.footer-link--disabled {
  cursor:
    default;

  opacity:
    0.45;
}

.footer-link--disabled:hover {
  transform:
    none;
}


/* ============================================================
   ABOUT COLUMN
============================================================ */

.footer-about-column {
  display: flex;

  flex-direction: column;

  align-items: center;

  gap:
    12px;

  padding-top:
    18px;

  padding-bottom:
    18px;

  text-align:
    center;
}

.footer-logo-link {
  display:
    block;

  width:
    100%;

  text-decoration:
    none;
}

.footer-logo {
  width: 180px;

  max-width: 100%;

  height: 42px;

   margin: 0 auto;
}

.footer-logo
:deep(.v-img__img) {
  object-fit:
    contain !important;

  object-position:
    center center !important;
}

.footer-about-description {
  width:
    100%;

  padding-top:
    3px;

  font-size:
    0.9rem;

  line-height:
    1.65;

  text-align:
    center;

  opacity:
    0.78;
}

.footer-contact-link {
  display:
    inline-flex;

  align-items:
    center;

  justify-content:
    center;

  gap:
    8px;

  font-size:
    0.88rem;

  text-decoration:
    none;

  opacity:
    0.78;

  transition:
    opacity 0.2s ease;
}

.footer-contact-link:hover {
  opacity:
    1;
}


/* ============================================================
   BOTTOM BAR
============================================================ */

.footer-bottom {
  position:
    relative;

  z-index:
    89;

  width:
    100%;
}


/* Vertical spacing belongs inside the container content,
   not in responsive-x-padding.
*/
.footer-divider {
  margin-top:
    28px;

  margin-bottom:
    20px;

  opacity:
    0.35;
}

.footer-bottom-content {
  display:
    flex;

  align-items:
    center;

  justify-content:
    space-between;

  gap:
    24px;

  padding-bottom:
    28px;
}


/* ============================================================
   POLICY / COMPANY
============================================================ */

.footer-policy-links,
.footer-company-information {
  display:
    flex;

  flex-wrap:
    wrap;

  align-items:
    center;

  gap:
    10px
    18px;
}

.privacycss {
  display:
    inline-flex;

  align-items:
    center;

  gap:
    6px;

  padding:
    5px
    0;

  margin:
    0;

  font:
    inherit;

  font-size:
    0.82rem;

  text-decoration:
    none;

  background:
    none;

  border:
    0;

  cursor:
    pointer;

  opacity:
    0.78;

  transition:
    opacity 0.2s ease;
}

.privacycss:hover {
  opacity:
    1;
}

.footer-location {
  cursor:
    default;
}


/* ============================================================
   TABLET
============================================================ */

@media (max-width: 959px) {
  .footer-bottom-content {
    align-items:
      flex-start;

    flex-direction:
      column;
  }
}


/* ============================================================
   PHONE
============================================================ */

@media (max-width: 599px) {
  .footer-content {
    padding-top:
      36px;

    padding-bottom:
      36px;
  }

  .footer-column {
    padding-right:
      4px;

    padding-left:
      4px;
  }

  .footer-policy-links,
  .footer-company-information {
    align-items:
      flex-start;

    flex-direction:
      column;

    gap:
      5px;
  }

  .footer-about-column {
    align-items:
      center;

    text-align:
      center;
  }

  .footer-logo {
    max-width:
      280px;
  }
}
</style>